
<!-- http请求出现错误 页面-->
<template>

  <div class="box">
    <div class="errorTips">{{loginErrorMsg}}</div>
    <div @click="back">
      <img src="../assets/back4.png" class="turn" style="  position: fixed;left: 0px;top: 0px;width: 80px;height:80px;z-index:9999; " id="musicStopIco">
    </div>
  </div>
</template>

<script>
  // console.log('%c 接收到的参数：'+this.$route.params.msg,'font-size:30px;color:blue;');
    export default {
        name: "LoginError",
      data:function(){
        return{
          loginErrorMsg:''
        }
      },
        mounted() {
          this.getUrlParams();
        },
        methods:{
          getUrlParams(){
            const msg =window.localStorage.getItem('loginErrorMsg');
            this.loginErrorMsg =msg;
            console.log('%c 接受的参数：'+msg,'font-size:30px;')
          },
          back(){
            this.$router.push('/');
          }
        }
    }
</script>

<style scoped>
  @import "../assets/fonts/font.css";
  .box{
    background-image: url("../assets/loginError.png");
    width: 100%;
    height: 100%;
    background-size: 100%;



  }
  .errorTips{
    font-family: myMind;
    font-size: 40px;
    padding-top: 18%;
  }
</style>



// WEBPACK FOOTER //
// src/views/LoginError.vue